module.exports = __webpack_public_path__ + "media/angular-engine/app/account/candidates/list/empty-7b15dff7bae2d86e7c7da963de8263ff.png";